import React, { JSX } from "react";
import rwLogo from "../../assets/RW_Logo_W.png";
import artistryLogo from "../../assets/53A_logo_white.png";

const Partners = (): JSX.Element => {
  const partnersData = [
    {
      id: 1,
      name: "53 Artistry",
      image: artistryLogo,
      alt: "53 Artistry - Embrace Distinction",
      url: "https://www.53artistry.com/",
    },
    {
      id: 2,
      name: "Rinkwear",
      image: rwLogo,
      alt: "Rinkwear - Built for the Barn",
      url: "https://www.53artistry.com/",
    },
  ];

 return (
  <section id="partners" className="relative bg-[#080d1b] flex items-center justify-center py-20 px-6 overflow-hidden">
    {/* Glass panel background */}
    <div
      className="absolute top-[5%] left-[5%] right-[5%] 
                 h-[300px] md:h-[300px] lg:h-[460px]
                 rounded-[40px] border-[5px] border-[#3654a1]
                 shadow-[0_0_20px_#1d3c8c40]
                 backdrop-blur-sm backdrop-brightness-100"
      aria-hidden="true"
    />

    {/* Foreground content */}
    <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-10 max-w-6xl w-full items-center">
      {/* Left side: Header */}
      <header className="text-center md:text-left self-center md:pl-20">
        <h1 className="
                       [font-family:'Sen-Bold',Helvetica]
                       font-bold text-[#dee3f2]
                       text-4xl md:text-5xl lg:text-5xl
                       leading-tight text-center md:text-center">
          Trusted <span className="text-[#2b61de]">Partners</span>
        </h1>
      </header>

      {/* Right side: Partner logos */}
      <section
        className="flex md:flex-col justify-center items-center gap-6 w-full"
        aria-label="Partner companies"
      >
        {partnersData.map((partner) => (
          <a
            key={partner.id}
            href={partner.url}
            target="_blank"
            rel="noopener noreferrer"
            className="w-[60%] max-w-[150px] md:max-w-[400px] lg:max-w-[450px]
                       aspect-[2/1] border-[5px] border-[#263e81]
                       shadow-lg rounded-[30px]
                       flex items-center justify-center bg-[#0a1229] p-6
                       transition-transform transform hover:scale-105 hover:shadow-[0_0_50px_#2B61DEbf]"
          >
            <img
              className="w-[80%] h-auto object-contain"
              alt={partner.alt}
              src={partner.image}
              loading="lazy"
            />
          </a>
        ))}
      </section>
    </div>
  </section>
);
};

export default Partners; // <-- changed to default export
